import { z } from "zod";

/** Represents the enum public.event_type */
type EventType = "some_type";

export default EventType;

/** Zod schema for event_type */
export const eventType = z.enum(["some_type"]);
